/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {WealthyEnv} from "helpers";
import {createGlobalStyle} from "styled-components";

const mavenProRegular = WealthyEnv.IS_PRODUCTION ? `${WealthyEnv.WEALTHY_FONT}/maven-pro-regular.woff` : "https://ik.imagekit.io/aboutUs/maven-pro-regular_FqrVOLw8M.woff?ik-sdk-version=javascript-1.4.3&updatedAt=1658744597210";

const mavenProBold = WealthyEnv.IS_PRODUCTION ? `${WealthyEnv.WEALTHY_FONT}/maven-pro-extra-bold.woff` : "https://ik.imagekit.io/aboutUs/maven-pro-extra-bold_10FG-dT-V.woff?ik-sdk-version=javascript-1.4.3&updatedAt=1658744596951";

const dmSerifRegular = WealthyEnv.IS_PRODUCTION ? `${WealthyEnv.WEALTHY_FONT}/dm-serif-regular.woff` : "https://ik.imagekit.io/aboutUs/DMSerifDisplay-Regular_nSADXHWHO_SiyC42Evq.woff?ik-sdk-version=javascript-1.4.3&updatedAt=1658744596872";

const dmSerifItalic = WealthyEnv.IS_PRODUCTION ? `${WealthyEnv.WEALTHY_FONT}/dm-serif-italic.woff` : "https://ik.imagekit.io/aboutUs/DMSerifDisplay-Italic_fPV1UbLi-.woff?ik-sdk-version=javascript-1.4.3&updatedAt=1658744879282";


const latestLatoRegular = `${WealthyEnv.CDN_URL}/articles/Latest-Lato-Bold.ttf`;

const latestLatoBold = `${WealthyEnv.CDN_URL}/articles/Latest-Lato-Bold.ttf`;

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: MavenPro;
    src: url(${mavenProRegular}) format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: MavenPro-Bold;
    src: url(${mavenProBold}) format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: DMSerif-Italic;
    src: url(${dmSerifItalic}) format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: DMSerif-Regular;
    src: url(${dmSerifRegular}) format("woff");
    font-display: swap;
  }

  @font-face {
    font-family: Latest-Lato-Regular;
    src:url(${latestLatoRegular}) format("ttf");
    font-display: swap;
  }

  @font-face {
    font-family: Latest-Lato-Bold;
    src:url(${latestLatoBold}) format("ttf");
    font-display: swap;
  }

  *,*::after,*::before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }

  body {
    line-height: 1.7;
    overflow-x: hidden;
    font-family: MavenPro;

    ::-webkit-scrollbar {
      width: 0;
      background: transparent;
    }

  ::-webkit-scrollbar-thumb {
      background: transparent;
    }

  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  /* W3C: cursor: hand is deprecated; override slick-carousel */
  .slick-list.dragging {
    cursor: pointer;
  }

  /* W3C: Fix invalid font-weight string values (e.g. '400') from libraries */
  .recharts-default-tooltip,
  .recharts-tooltip-wrapper,
  .Toastify__toast,
  .Toastify__toast-body {
    font-weight: 400;
  }

  /* W3C: Override invalid font-weight: '400' from styled-components (hash may change on rebuild) */
  .jVhOeY {
    font-weight: 400 !important;
  }

  /* W3C: Override invalid font-style: Regular from styled-components (hash may change on rebuild) */
  .hvInbT {
    font-style: normal !important;
  }

  .dropdown-menu .dropdown-menu__item:hover {
    background: #fff;
    color: #6725f4;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .hide-scroll {
    overflow: hidden;
    height: 100%;
  }

  .visible {
    opacity: 1;
    transition: opacity 1s ease-out;
  }

  a, button, input {
    outline: none;
  }

  a {
    display: inline-block;
    color: black;
    text-decoration: none;
    font-size: 1.6rem;
    font-family: MavenPro;
  }

  ul {
    list-style-type: none;
  }

  .fade-in {
    opacity: 0;
    transform: translateY(50px);
  }

  .in-view {
    opacity: 1;
    transform: translateY(0);
    transition: all 1s ease;
  }

  .desktop-only {
    display: block !important;
  }

  .step {
    font-weight: 600;
  }

  @media (max-width : 75rem) {
    html {
      font-size : 56.25%;
    }
  }

  @media (max-width: 768px) {
    .mobile-only {
      display: block !important;
    }
  }

  /* Footer Styles */

footer {
  background-color: #f9f9f9;
  position: relative;
}
footer ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  margin-top: 4rem;
}
footer ul li a {
  color: #1c1c1c !important;
  display: block;
  line-height: 2.2;
  font-size: 14px;
  text-decoration: none;
  color: #1c1c1c;
}
footer ul li a:hover, footer ul li a:focus, footer ul li a:active {
  opacity: 1;
  color: #1c1c1c;
  text-decoration: none;
}
footer h4 {
  font-size: 18px;
  font-weight: 500;
  color: #1c1c1c;
  padding-bottom: 10px;
}

.footer {
  padding-bottom: 30px;
}

.anchor-footer {
  font-size: 1.3rem;
  color: #4a90e2;
}

.wl-footer {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 85%;
  margin: auto;
  max-width: 1250px;
  padding: 2.7em 1em;
  align-items: baseline;
}
.wl-basic-social-container {
  -webkit-box-flex: 4;
  -webkit-flex: 4;
  -ms-flex: 4;
  flex: 4;
  flex-direction: column;
}
.wl-social-container {
  margin-top: 2rem;
  >h2 {
    color: #1c1c1c;
    font-size: 1.6rem;
    padding-bottom: 0.1em;
    margin-bottom: 2rem;
  }
  .wl-social-wrapper {
    display: flex;
    justify-content: space-between;
    width: 70%;
  }
}
.wl-basic img.logo {
  width: 150px;
}
.wl-basic .mix-panel-logo img {
  width: 75px;
}
img.download-app {
  margin-top: 10px;
  width: 150px;
}
.wl-basic .logo-text {
  font-size: 14px;
  color: #1c1c1c;
  width: 250px;
  margin-top: 20px;
  font-weight: 300;
}
.wl-basic ul.social {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.wl-basic ul.social li {
  margin: auto 5px;
}
.wl-basic ul.social li i {
  font-size: 1.2em;
}

.wl-marketing {
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 85%;
  margin: 0 auto 2rem;
  max-width: 1250px;
  padding: 3rem 1.5em;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
}

.wl-marketing .download-app {
  margin-top: 0;
  display: flex;
  align-items: center;
}

.wl-marketing .download-app .download-app-text {
  font-size: 2.2rem;
  color: #1c1c1c;
  font-weight: 300;
  opacity: 0.9;
}

.wl-marketing .download-app .download-app-list {
  margin-top: 0;
  display: flex;
}

.wl-marketing .download-app .download-app-item {
  margin-left: 1em;
  width: 15rem;
}

.wl-marketing .download-app .download-app-link {
  line-height: 1;
}

.wl-marketing .download-app .download-app-icon {
  width: 100%;
  max-width: 100%;
}

.wl-products {
  -webkit-box-flex: 3;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
}
.wl-products > p:first-child,
.wl-links > p:first-child,
.wl-social-container > p:first-child {
  color: #1c1c1c;
  font-size: 16px;
  padding-bottom: 0.1em;
  margin: 0 0 20px;
  font-weight: 600;
}
.wl-products a, .wl-links a {
  color: #1c1c1c;
  text-decoration: none;
  display: block;
  font-size: 15px;
  line-height: 1.62em;
  font-weight: 300;
  opacity: 0.7;
}

.wl-products a:hover{
  opacity: 1 !important;
}

.wl-links {
  -webkit-box-flex: 2;
  -webkit-flex: 2;
  -ms-flex: 2;
  flex: 2;
}
@media screen and (max-width: 525px) {
  .wl-footer {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .wl-basic {
    text-align: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-right: 0px;
  }
  .wl-basic ul.social {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 2em;
  }
  .wl-products {
    text-align: center;
    border-bottom: 1px solid white;
    padding-bottom: 1em;
    display: none;
  }
  .wl-products:last-child {
    border-bottom: none;
  }
  .wl-links {
    text-align: center;
 }
  .wl-products > p:first-child,
  .wl-links > p:first-child,
  .wl-social-container > p:first-child {
    padding-bottom: 0px;
 }
  .wl-dropdown-menu {
    min-width: 285px;
 }
}
@media screen and (min-width: 526px) and (max-width: 740px) {
  .wl-footer {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
 }
  .wl-basic {
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
    width: 100%;
    text-align: center;
  }
  .wl-basic .logo-text {
    margin: auto;
    padding-bottom: 1em;
  }
  .wl-basic ul.social {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .wl-products {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
  .wl-links {
    text-align: right;
  }
}

.footer-disclaimer {
  width: 85%;
	margin: auto;
	max-width: 1250px;
	padding-top: 1.2em;
}
.footer-disclaimer p, .footer-disclaimer span {
	font-size: 12px;
	color: #1c1c1c;
}
.footer-disclaimer p {
	margin-bottom: 10px;
}
.footer-copyright-container {
	margin-top: 5rem;
	border-top: 1px solid #ccc;
}
.footer-copyright{
	width: 85%;
	margin: auto;
	padding: 2rem 0 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.copyright-text-name {
	color: #61788e;
	font-family: Avenir-Heavy;
}
.copyright-text {
	color: #9aa8b6;
	font-family: Avenir-Book;
	font-size: 1.4rem;
}
.copyright-text-links {
  font-size: 1.3rem;
	color: #4a90e2;
	font-family: Avenir-Book;
}
.copyright-text-links:hover {
	text-decoration: underline;
}
.footer-copyright .social {
	display: inline-flex;
	align-items: center;
	margin-top: 0;
}
.footer-copyright .social .social-item {
	margin-left: 1.5rem;
}
.Toastify {
  font-size: 1.4rem;
}
.Toastify__toast {
  min-height: 54px;
}

@media screen and (max-width: 1044px) and (min-width: 741px) {
  .wl-basic {
    -webkit-box-flex: 5;
    -webkit-flex: 5;
    -ms-flex: 5;
    flex: 5;
  }
  .wl-products {
    -webkit-box-flex: 4;
    -webkit-flex: 4;
    -ms-flex: 4;
    flex: 4;
  }
  .wl-links {
    -webkit-box-flex: 3;
    -webkit-flex: 3;
    -ms-flex: 3;
    flex: 3;
  }
}

@media (max-width: 768px) {
  .wl-social-container {
    .wl-social-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
  .wl-marketing .download-app {
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
  }
}

`;

export default GlobalStyle;
